import { SnapshotResponse } from '../../api-models';
import { Snapshot } from '../../types/core.type';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class GetLatestSnapshot extends BaseAdapter<SnapshotResponse> implements AdapterInterface {
  rawResponse: SnapshotResponse;

  async adaptResponse(): Promise<Snapshot> {
    await this.fetchApiResponse('/api/latest-snapshot', HTTPMethod.Get);
    return this.displayResponse();
  }

  displayResponse(): Snapshot {
    return {
      rawSnapshot: this.rawResponse.snapshot,
      formattedSnapshot: this.rawResponse.formatted_snapshot,
    };
  }
}
